import { Spin } from 'antd';
import classNames from 'classnames';
import parse from 'html-react-parser';
import moment from 'moment';
import useQuery from '../../../../util/useQuery';

export default function PreviewArticleEn({ detail, loading, logo }) {
    const personalDataCollection = detail?.personalDataCollection;
    const disclosurePersonalData = detail?.disclosurePersonalData;
    // const personalDataTopic = detail?.disclosurePersonalData?.personalDataTopic;
    const dataSubjectRightAndSecure = detail?.dataSubjectRightAndSecure;
    const marketingAdvertising = detail?.marketingAdvertising;
    const privacyPolicy = detail?.privacyPolicy;
    const dataController = detail?.dataController;
    const dpo = detail?.dpo;
    const params = useQuery();

    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                                {personalDataCollection?.companyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            personalDataCollection?.companyNameEn
                                        }
                                    />
                                )}
                                <h3>
                                    Privacy Notice{' '}
                                    {personalDataCollection?.companyNameEn}
                                </h3>
                                <p className="indent-8 text-left">
                                    {personalDataCollection?.companyNameEn}{' '}
                                    suggest our Subscriber to understand this
                                    Privacy Policy,We provide this privacy
                                    notice to inform our customers of our policy
                                    in relation to this policy is prescribed the
                                    process of data collect, store, use and
                                    disclose including other rights of
                                    Subscriber (“Data Subject”). Therefore,
                                    {personalDataCollection?.companyNameEn}{' '}
                                    would like to announce the Policy as
                                    followings:
                                </p>
                            </div>
                            {(disclosurePersonalData?.personalDataOptionSequence
                                ?.length !== 0 ||
                                disclosurePersonalData
                                    ?.sensitivePersonalDataOptionSequence
                                    ?.length !== 0) && (
                                <>
                                    <h4>Personal Data</h4>
                                    <p className="indent-8">
                                        “Personal Data” means any information
                                        pertaining to a Data Subject, which
                                        enables the identification of Data
                                        Subject, whether direct or indirect.
                                    </p>
                                    <h4>Data collection</h4>
                                    <p className="indent-8">
                                        We collect, use or disclose your
                                        personal data followings:
                                    </p>
                                    <table
                                        border={0}
                                        style={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                            borderStyle: 'hidden',
                                            borderColor: '#f9f9f9',
                                            backgroundColor: '#f9f9f9',
                                            marginBottom: '5px',
                                            textAlign: 'left',
                                            padding: '1rem',
                                            borderRadius: 6,
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    style={{
                                                        padding: '1rem',
                                                    }}
                                                >
                                                    Type of Personal Data
                                                </th>
                                                <th
                                                    style={{
                                                        padding: '1rem',
                                                    }}
                                                >
                                                    Personal Data
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {disclosurePersonalData
                                                ?.personalDataOptionSequence
                                                ?.length !== 0 && (
                                                <tr
                                                    style={{
                                                        borderTop:
                                                            '1px solid #e9e9e9',
                                                    }}
                                                >
                                                    <td
                                                        style={{
                                                            width: '40%',
                                                            paddingLeft: '1rem',
                                                        }}
                                                    >
                                                        Personal data
                                                    </td>
                                                    <td>
                                                        <ul
                                                            style={{
                                                                paddingLeft:
                                                                    '0px',
                                                            }}
                                                        >
                                                            {disclosurePersonalData?.personalDataOptionSequence?.map(
                                                                (option, i) => (
                                                                    <li key={i}>
                                                                        {option.personDataOptionNameEn
                                                                            ? option.personDataOptionNameEn
                                                                            : option.personDataOptionNameTh}
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    </td>
                                                </tr>
                                            )}
                                            {disclosurePersonalData
                                                ?.sensitivePersonalDataOptionSequence
                                                ?.length !== 0 && (
                                                <tr
                                                    style={{
                                                        borderTop:
                                                            '1px solid #e9e9e9',
                                                    }}
                                                >
                                                    <td
                                                        style={{
                                                            width: '40%',
                                                            paddingLeft: '1rem',
                                                        }}
                                                    >
                                                        Sensitive Personal data
                                                    </td>
                                                    <td>
                                                        <ul
                                                            style={{
                                                                paddingLeft:
                                                                    '0px',
                                                            }}
                                                        >
                                                            {disclosurePersonalData?.sensitivePersonalDataOptionSequence?.map(
                                                                (option, i) => (
                                                                    <li key={i}>
                                                                        {option.sensitivePersonDataOptionNameEn
                                                                            ? option.sensitivePersonDataOptionNameEn
                                                                            : option.sensitivePersonDataOptionNameTh}
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </>
                            )}
                            <h4>Sources of your personal data</h4>
                            <p className="indent-8">
                                We may get your personal data from the following
                                channels:
                            </p>
                            {personalDataCollection?.dataSourceFromDs && (
                                <>
                                    <h4>
                                        Collect personal data directly from you
                                        ("Data Subject"){' '}
                                    </h4>
                                    {parse(
                                        `${
                                            personalDataCollection?.dataSourceFromDsEn ||
                                            '-'
                                        }`
                                    )}
                                </>
                            )}

                            {personalDataCollection?.dataSourceFromOther && (
                                <>
                                    <h4>
                                        Collect personal data from Other sources
                                    </h4>

                                    {parse(
                                        `${
                                            personalDataCollection?.dataSourceFromOtherEn ||
                                            '-'
                                        }`
                                    )}
                                </>
                            )}

                            <h4>
                                Purpose of Collect,Use or disclose your personal
                                data
                            </h4>

                            {parse(
                                `${
                                    personalDataCollection?.purposeOfDataCollectionEn ||
                                    '-'
                                }`
                            )}

                            <h4>Disclose personal data to others</h4>
                            <p className="indent-8 whitespace-pre-wrap">
                                The company will not disclose your personal
                                information to other individuals and juristic
                                persons who are not affiliated companies of the
                                company ("other people") unless it is disclosed
                                to achieve the purpose of collecting and
                                processing personal information as specified in
                                this privacy notice. The company may disclose
                                your personal information to other people such
                                as{' '}
                            </p>

                            {parse(
                                `${
                                    disclosurePersonalData?.discloseToOtherPersonEn ||
                                    '-'
                                }`
                            )}

                            <h4>Retention period of personal data</h4>

                            {parse(
                                `${
                                    disclosurePersonalData?.retentionPeriodEn ||
                                    '-'
                                }`
                            )}

                            <h4>International transfer of personal data</h4>

                            {parse(
                                `${
                                    disclosurePersonalData?.transferPersonalDataEn ||
                                    '-'
                                }`
                            )}

                            <h4>Right of Data Subject</h4>
                            <p className="indent-8 whitespace-pre-wrap">
                                You can exercise your rights under the
                                PDPA,details as specified below, through the
                                channels prescribed by us:
                            </p>
                            <ul>
                                <li>
                                    <h4>Right to withdraw consent</h4>
                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToWithdrawConsentEn ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>Right to access and obtain copy</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightOfAccessEn ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>Right to data portability</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightOfDataPortabilityEn ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>Right to object</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToObjectEn ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>Right to restrict</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToRestrictProcessingEn ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>Right to erasure</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToErasureEn ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>Right to rectification</h4>
                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToRectificationEn ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                {dataSubjectRightAndSecure?.rightToComplaintEn && (
                                    <li>
                                        <h4>Right to Complaint</h4>
                                        {parse(
                                            `${
                                                dataSubjectRightAndSecure?.rightToComplaintEn ||
                                                '-'
                                            }`
                                        )}
                                    </li>
                                )}
                            </ul>
                            <h4>How security measures and quality of data</h4>

                            {parse(
                                `${
                                    dataSubjectRightAndSecure?.securityMeasureEn ||
                                    '-'
                                }`
                            )}

                            <h4>
                                What are the marketing and promotional
                                activities
                            </h4>

                            {parse(
                                `${
                                    marketingAdvertising?.marketingActivityEn ||
                                    '-'
                                }`
                            )}

                            <h4>
                                What are the privacy policies of other websites
                            </h4>

                            {parse(`${privacyPolicy?.policyWebsiteEn || '-'}`)}

                            <h4>
                                Please explain if the data subject denies giving
                                you the necessary information for providing your
                                services
                            </h4>

                            {parse(
                                `${privacyPolicy?.undisclosedReasonEn || '-'}`
                            )}

                            <h4>
                                What are the actions, practices and policies
                                regarding personal data
                            </h4>

                            {parse(`${privacyPolicy?.processPolicyEn || '-'}`)}

                            <h4>Data Protection Officer</h4>

                            {parse(`${dpo?.dpoNameEn}`)}

                            <h4>Contact channel</h4>

                            {parse(
                                `${dataController?.contactChannelEn || '-'}`
                            )}

                            <h4>
                                Edition as of{' '}
                                {personalDataCollection?.effectiveDate
                                    ? moment(
                                          personalDataCollection?.effectiveDate
                                      )
                                          .locale('en')
                                          .format('LL')
                                    : '-'}
                            </h4>
                        </article>
                    </div>
                </div>
            </div>
        </Spin>
    );
}
